import { Component, Input } from '@angular/core';
import { Dialogue, DialogueLogicKey } from '@kp/dialogue/models/dialogue.model';

@Component({
  selector: 'kp-dialogue-information',
  templateUrl: './dialogue-information.component.html',
  styleUrls: ['./dialogue-information.component.scss'],
})
export class DialogueInformationComponent {
  @Input() dialogue: Dialogue;
  @Input() isEmbedded = false;
  DialogueLogicKey = DialogueLogicKey;
}
